import React from "react";
import styled, { css } from "styled-components";
import useHistory from "routing/useHistory";
import { IconButton, Spinner } from "components/common";
import ActiveInvestigationLabel from "security-app/components/Investigations/ActiveInvestigationLabel";
import { Button } from "components/bootstrap";
import useRightSidebar from "hooks/useRightSidebar";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { useGetInvestigationDetails } from "security-app/hooks/useInvestigationsAPI";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import AIReportButton from "security-app/components/Investigations/AIReport/AIReportButton";
import Routes from "security-app/routing/Routes";
import useInvestigationPanel from "security-app/components/Investigations/hooks/useInvestigationPanel";
import Details from "../Drawer/Details";
import Evidence from "../Drawer/Evidence";
import Notes from "../Drawer/Notes";
const SectionDivider = styled.hr(
  ({ theme }) => css`
    border-color: ${theme.colors.input.border};
    margin: 16px 0;
  `
);
const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  h3 {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    min-width: 0;
    overflow: hidden;
  }
`;
const InvestigationName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const HeaderButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;
function InvestigationSidebarContent({ investigationId }) {
  var _a;
  const { push } = useHistory();
  const { collapseSidebar } = useRightSidebar();
  const sendTelemetry = useSendTelemetry("investigation");
  const { selectedInvestigationId, setSelectedInvestigationId } = useInvestigationPanel();
  const { loadingInvestigationDetails, currentInvestigation } = useGetInvestigationDetails(investigationId);
  const isAIReportFeatureEnabled = useIsInvestigationAIReportEnabled();
  if (loadingInvestigationDetails || !currentInvestigation) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading investigation details..." });
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderDiv, null, /* @__PURE__ */ React.createElement("h3", null, /* @__PURE__ */ React.createElement(InvestigationName, null, (_a = currentInvestigation.name) != null ? _a : ""), " ", investigationId === selectedInvestigationId && /* @__PURE__ */ React.createElement(ActiveInvestigationLabel, null, "Active")), /* @__PURE__ */ React.createElement(HeaderButtons, null, !currentInvestigation.archived && investigationId !== selectedInvestigationId && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsSize: "xs",
      onClick: () => {
        sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_SET_AS_ACTIVE, {
          app_pathname: "security",
          event_details: { investigation_id: investigationId }
        });
        setSelectedInvestigationId(investigationId);
      }
    },
    "Set as active"
  ), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "open_in_new",
      title: "View full investigation details",
      onClick: () => {
        sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_NAVIGATED_TO_DETAILS, {
          app_pathname: "security",
          event_details: { investigation_id: investigationId }
        });
        collapseSidebar();
        push(Routes.INVESTIGATIONS.details(investigationId));
      }
    }
  ), isAIReportFeatureEnabled && /* @__PURE__ */ React.createElement(AIReportButton, { investigation: currentInvestigation, small: true, logsCount: currentInvestigation.logs_count }))), /* @__PURE__ */ React.createElement(SectionDivider, null), /* @__PURE__ */ React.createElement(Details, { investigation: currentInvestigation }), /* @__PURE__ */ React.createElement(SectionDivider, null), /* @__PURE__ */ React.createElement(Evidence, { investigation: currentInvestigation }), /* @__PURE__ */ React.createElement(SectionDivider, null), /* @__PURE__ */ React.createElement(Notes, { investigation: currentInvestigation }));
}
export default InvestigationSidebarContent;
